export default __webpack_public_path__ + "50f387b4b56670e1ac47b0cbb100e394.svg";